import { apiReferralFetch, defaultErrorMsg } from '../index';
import type {
  CreateManualAttributionBody,
  ManualAttributionResult,
} from '../introducer-dashboard/types';
import type { IntroducerMembership } from './types';

export type ReferralIntroductionActivateBody = {
  code: string;
  subjectId: string;
  subjectType: 'fund';
};

export const _postReferralIntroductionActivate = (body: ReferralIntroductionActivateBody) => {
  return apiReferralFetch('/introductions/activate', {
    method: 'POST',
    body,
    onResponseError: ({ response }) => {
      defaultErrorMsg(response);
    },
  });
};

export const _postManualAttribution = (body: CreateManualAttributionBody) => {
  return apiReferralFetch<ManualAttributionResult>('/internal/introducer/manual-attribution', {
    method: 'POST',
    body,
  });
};

export const _postPauseIntroducer = (userId: string) => {
  return apiReferralFetch<IntroducerMembership>(`/admin/introducers/${userId}/pause`, {
    method: 'POST',
  });
};

export const _postUnpauseIntroducer = (userId: string) => {
  return apiReferralFetch<IntroducerMembership>(`/admin/introducers/${userId}/unpause`, {
    method: 'POST',
  });
};

export const validateReferralCode = (code: string) =>
  apiReferralFetch<{ valid: boolean }>('/codes/validate', { method: 'POST', body: { code } });
